module.exports = __webpack_public_path__ + "static/footer-cover-2.52e7d78d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer-cover-2.jpg
// module id = 549
// module chunks = 114276838955818